// extracted by mini-css-extract-plugin
export default {"textbox-container":"styles_textbox-container__RB43m","textbox":"styles_textbox__yFeu5","error":"styles_error__MNrmG","error-message":"styles_error-message__pO4Es"};